import { render, staticRenderFns } from "./AudioNoticeboardContent.vue?vue&type=template&id=0341bbe5&"
import script from "./AudioNoticeboardContent.vue?vue&type=script&lang=js&"
export * from "./AudioNoticeboardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput});
